"use client"

import fetchInterceptorInClient from "@/components/fetcher/fetchInterceptorInClient"
import {
  resultPostprocessing2,
} from "@/components/fetcher/fetchInterceptor"

const ROOT = process.env.NEXT_PUBLIC_ROOT

export type ScrapIdEntry = {
  id: string
  sentenceId: string
}

// 다른 사람의 콘텐츠에 대한 내 폴더 엔트리 목록(스크랩) 조회
const fetchClientScrapIds = () => {
  return fetchInterceptorInClient(
    {
      method: "get",
      credentials: "same-origin",
    },
    ROOT,
  )(() => `/api/notebook/scraped-sentence/folder-entries/others/ids`, {
    size: 999,
  }).then(resultPostprocessing2<ScrapIdEntry[]>)
}

export default fetchClientScrapIds
